import { render, staticRenderFns } from "./InStoreProductType.vue?vue&type=template&id=3954bb34"
import script from "./InStoreProductType.vue?vue&type=script&lang=js"
export * from "./InStoreProductType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports